import { motion } from "framer-motion";

export const SectionHeader = ({ overline, title, subtitle, align = "center" }) => (
  <div className={align === "center" ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
    {overline && (
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-600 dark:text-cyan-400"
      >
        {overline}
      </motion.p>
    )}
    <motion.h2
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0.05 }}
      className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tight text-slate-950 dark:text-white"
    >
      {title}
    </motion.h2>
    {subtitle && (
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
        className="mt-3 text-base text-slate-600 dark:text-slate-400"
      >
        {subtitle}
      </motion.p>
    )}
  </div>
);
